/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreTimesheetCreateDto } from '../../models/core-timesheet-create-dto';
import { CoreTimesheetResponseDto } from '../../models/core-timesheet-response-dto';

export interface TimesheetsControllerCreate$Params {

/**
 * Tenant identifier
 */
  tenant: string;
      body: CoreTimesheetCreateDto
}

export function timesheetsControllerCreate(http: HttpClient, rootUrl: string, params: TimesheetsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, timesheetsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreTimesheetResponseDto>;
    })
  );
}

timesheetsControllerCreate.PATH = '/o2-core/timesheets/{tenant}';
